module.exports = __webpack_public_path__ + "static/media/qijizaixian.fc10c4b.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qijizaixian.mp3
// module id = Y67q
// module chunks = 1